<template>
  <div class="pa-4">
    <v-menu bottom offset-y>
      <template v-slot:activator="{ on }">
        <v-btn small v-on="on">Gabarito</v-btn>
      </template>
      <v-list dense>
        <v-list-item @click="type = null">(nenhum)</v-list-item>
        <v-list-item v-for="t in types" :key="t" @click="type = t">{{
          t
        }}</v-list-item>
      </v-list>
    </v-menu>
    <pre class="protocol-help">{{ help }}</pre>
  </div>
</template>

<script>
const HELP_LAPSE = `        ┌─────┬─────┬─────┬─────┬─────┬─────┬─────┬─────┐
 LAPSO  │ CC1 │ CC1 │ RPM │SPEED│ DG  │ACCEL│ AN1 │EXP1 │
        ├─────┴─────┴─────┴─────┴─────┴─────┴─────┴─────┤
        │(1) RPM                                        │
        │(1) SPEED                                      │
        ├─────┬─────┬─────┬─────┬─────┬─────┬─────┬─────┤
 DG     │ DG3 │BRAKE│ DG1 │ DG2 │BUZZ │ ACT │INCOD│NOTFX│
        ├─────┴─────┴─────┴─────┴─────┴─────┴─────┴─────┤
        │(1) ACCEL                                      │
        │(2) AN1                                        │
        ├─────┬─────┬─────┬─────┬─────┬─────┬─────┬─────┤
 EXP1   │ AN2 │ AN3 │ AN4 │STATE│POLY │ GPS │ OPE │EXP2 │
        ├─────┴─────┴─────┴─────┴─────┴─────┴─────┴─────┤
        │(2) AN2                                        │
        │(2) AN3                                        │
        │(2) AN4                                        │
        │(1) STATE                                      │
        │(1) POLY                                       │
        │(4) LATITUDE                                   │
        │(4) LONGITUDE                                  │
        │(1) OPERATION TYPE                             │
        │(n) OPERATION DATA                             │
        │...mais TYPE+DATA até que o bit 0 do tipo == 0 │
        ├─────┬─────┬─────┬─────┬─────┬─────┬─────┬─────┤
 EXP2   │FLAGS│  R  │  R  │  R  │  R  │  R  │  R  │EXP3 │
        ├─────┼─────┼─────┼─────┼─────┼─────┼─────┼─────┤
 FLAGS  │NOTFX│GPSVL│RPMAC│  R  │  R  │  R  │  R  │  R  │
        └─────┴─────┴─────┴─────┴─────┴─────┴─────┴─────┘`

const HELP_OFF_TRIP = `        ┌─────┬─────┬─────┬─────┬─────┬─────┬─────┬─────┐
 OFF-T  │  1  │  0  │  R  │  R  │  R  │  1  │  0  │  0  │ 0x84
        ├─────┴─────┴─────┴─────┴─────┴─────┴─────┴─────┤
        │(2) FWVERSION                                  │
        │(6) TIMESTAMP                                  │
        │(4) HORO                                       │
        │(4) ODO                                        │
        ├───────────────────────────────────────────────┤
        │LAPSO FULL                                     │
        └───────────────────────────────────────────────┘`

const HELP_HEADER = `           ┌─────┬─────┬─────┬─────┬─────┬─────┬─────┬─────┐
HEADER_ON  │  1  │  0  │  R  │  R  │  R  │  0  │  0  │  1  │ 0x81
           ├─────┴─────┴─────┴─────┴─────┴─────┴─────┴─────┤
           │(2) FWVERSION                                  │
           │(8) DRIVER_SERIAL                              │
           │(6) TIMESTAMP                                  │
           │(4) HORO                                       │
           │(4) ODO                                        │
           │(1) LAPTIME                                    │
           └───────────────────────────────────────────────┘`

const HELP_FOOTER = `           ┌─────┬─────┬─────┬─────┬─────┬─────┬─────┬─────┐
FOOTER     │  1  │  0  │  R  │  R  │  R  │  0  │  1  │  0  │ 0x82
           ├─────┴─────┴─────┴─────┴─────┴─────┴─────┴─────┤
           │(6) TIMESTAMP                                  │
           │(4) HORO                                       │
           │(4) ODO                                        │
           └───────────────────────────────────────────────┘
`

const HELP_HINTS = `Hints que podem ser inseridos no final de cada linha:

4154 # ascii         => A T
ff   # lapse         => byte de controle lapso-full
ff   # dg            => byte de sinais digitais
ff   # exp1          => byte de expansão 1
ff   # exp2          => byte de expansão 2
ff   # flags         => byte de flags
`
export default {
  data() {
    return {
      type: null,
      types: ['header', 'lapse', 'footer', 'off-trip', 'hints']
    }
  },
  computed: {
    help() {
      if (this.type == 'header') return HELP_HEADER
      if (this.type == 'lapse') return HELP_LAPSE
      if (this.type == 'footer') return HELP_FOOTER
      if (this.type == 'off-trip') return HELP_OFF_TRIP
      if (this.type == 'hints') return HELP_HINTS
      return ''
    }
  }
}
</script>

<style lang="sass">
.protocol-help
  font-family: monospace
  font-size: 14px
  line-height: normal
  background-color: antiquewhite
</style>
